import { memo } from 'react';
import PropTypes from 'prop-types';

import { ASSET_TYPE } from 'src/data/asset';
import { PROJECT_TYPE } from 'src/data/project';

import ContentOutline from './components/ContentOutline';
import { ContentSimple } from './components/ContentSimple';

const getContentComponent = (projectType, assetType) => {
  if (projectType === PROJECT_TYPE.blogPost && assetType === ASSET_TYPE.blogPostOutline) {
    return ContentOutline;
  }
  return ContentSimple;
};

const VariationEditableContent = ({
  className,
  projectType,
  assetType,
  content,
  onChange,
  onFocusChange,
  disabled,
  hideMarks,
  addons,
  setEditor,
  ...restProps
}) => {
  const ContentComponent = getContentComponent(projectType, assetType);

  return (
    <ContentComponent
      className={className}
      content={content}
      onChange={onChange}
      onFocusChange={onFocusChange}
      disabled={disabled}
      hideMarks={hideMarks}
      addons={addons}
      setEditor={setEditor}
      {...restProps}
    />
  );
};

VariationEditableContent.propTypes = {
  className: PropTypes.string,
  projectType: PropTypes.oneOf(Object.values(PROJECT_TYPE)),
  assetType: PropTypes.oneOf(Object.values(ASSET_TYPE)),
  content: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onChange: PropTypes.func.isRequired,
  onFocusChange: PropTypes.func,
  disabled: PropTypes.bool,
  hideMarks: PropTypes.bool,
  addons: PropTypes.arrayOf(PropTypes.elementType),
  setEditor: PropTypes.func,
};

VariationEditableContent.defaultProps = {
  className: null,
  projectType: null,
  assetType: null,
  onFocusChange: null,
  disabled: false,
  hideMarks: false,
  addons: [],
  setEditor: null,
};

export default memo(VariationEditableContent);
